var el, dropDown, search , resetSearch , listening = false;
let $ = window.jQuery;
function onDocumentReady(){
	if($('.filter-bar').length > 0){
		el = $('.filter-bar');
		dropDown = el.find('.dropdown-menu');
		search = el.find('#search');
		resetSearch = el.find('.reset-search');
		if(el && el.length > 0){
			listenForEvents(el);
		}
		$(window).on("load resize", function() {
			dropDown.removeClass('active').find('.options').slideUp();
			if($(window).width() >= 1000){
				el.find('.dropdown-menu').show();
			}
			else{
				el.find('.dropdown-menu').hide();
			}
		});
		$(document).mouseup(function (e){
		    var container = $('.dropdown-menu').find('.options');
			var currentDropdown = container.closest('.dropdown-menu');
			var dropDownLabel = $('.dropdown-menu').find('.dropdown-label');
			var dropDownText = $('.dropdown-menu').find('span');
			var dropDownIcon = $('.dropdown-menu').find('.icon');
		    if (!container.is(e.target) && !dropDownLabel.is(e.target) && !dropDownText.is(e.target) && !dropDownIcon.is(e.target) && container.has(e.target).length === 0){
		        currentDropdown.removeClass('active');
				container.stop().slideUp(200);
		    }
		});

		search.keyup(function(){
			$(this).closest('.input-wrapper').addClass('active-search');
		});

		resetSearch.click(function(){
			$(this).closest('.input-wrapper').find('#search').val('');
			$(this).closest('.input-wrapper').removeClass('active-search');
		});
	}
}

function listenForEvents(){
	if(!listening){
		el.on('click', '.title', onClickFilterBy);
		el.on('click', '.dropdown-label', onClickDropdownLabel);
		listening = true;
	}
}

function onClickDropdownLabel(e){
	var clicked = $(e.currentTarget);
	var triggereddropdown = clicked.closest('.dropdown-menu');
	if(triggereddropdown.hasClass('active')){
		triggereddropdown.removeClass('active');
		triggereddropdown.find('.options').stop().slideUp(200);
	}
	else{
		dropDown.removeClass('active').find('.options').stop().slideUp(200);
		triggereddropdown.addClass('active');
		triggereddropdown.find('.options').stop().slideDown(200);
	}
	e.stopImmediatePropagation();
	return false;
}

function onClickFilterBy(e){
	if($(window).width() <= 1000){
		el.find('.dropdown-menu').stop().slideToggle(200);
		e.stopImmediatePropagation();
		return false;
	}
}

document.addEventListener('DOMContentLoaded', onDocumentReady);



// WEBPACK FOOTER //
// ./wp-content/themes/stanleyelevator/assets/scripts/source/filter-bar-controller.js